module.exports = __webpack_public_path__ + "static/media/zoleLose_50000.33f9dbd8.png";